module.exports = __webpack_public_path__ + "assets/img/nature-c-bg1.b0b57d03.png";